import CardDiv from 'modules/common/card-div/CardDiv';
import CreateGroup from './CreateGroup';
import Group from './Group';

const TicketGroupMap = ({assigneeGroups}) => {
    return (
        <>
            <CardDiv title={
                <div className='d-flex justify-content-between'>
                    <h3>
                        Available Groups
                    </h3>
                    <CreateGroup />
                </div>
            }
                component={<div className='d-flex gap-2'>
                    {assigneeGroups.map(([groupName, groupMembers]) => {
                        return <Group key={groupName} groupName={groupName} groupMembers={groupMembers} />
                    })}
                </div>
                }
            />
        </>
    );
}

export default TicketGroupMap
